import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpClient } from '@angular/common/http';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class UploadFileAutomaticService {

	static ENV = environment;
	constructor(private httpService: HttpService) { }

	public loadJurnalsWS(data: any, httpRequesthandler: HttpRequestHandler): void {
		httpRequesthandler.headers = HEADERS;
		this.httpService.post(UploadFileAutomaticService.ENV.environment.API.load_journals_ws, data, httpRequesthandler);
	}

	public loadThirdPartyWS(data: any, httpRequesthandler: HttpRequestHandler): void {
		httpRequesthandler.headers = HEADERS;
		this.httpService.post(UploadFileAutomaticService.ENV.environment.API.load_third_party_ws, data, httpRequesthandler);
	}

	public validateThirdPartyWS(data: any, httpRequesthandler: HttpRequestHandler): void {
		httpRequesthandler.headers = HEADERS;
		this.httpService.post(UploadFileAutomaticService.ENV.environment.API.validate_third_party_ws, data, httpRequesthandler);
	}

	public compareBalanceWS(data: any, httpRequesthandler: HttpRequestHandler): void {
		httpRequesthandler.headers = HEADERS;
		this.httpService.post(UploadFileAutomaticService.ENV.environment.API.compare_balance_ws, data, httpRequesthandler);
	}

	public generateMediaAutomatic(data: any, httpRequesthandler: HttpRequestHandler): void {
		httpRequesthandler.headers = HEADERS;
		this.httpService.post(UploadFileAutomaticService.ENV.environment.API.generate_media_automatic, data, httpRequesthandler);
	}

}



// WEBPACK FOOTER //
// ./src/app/core/services/upload-file-automatic/upload-file-automatic.service.ts